<template>
    <div class="confirm-forget">
        <img src="https://testes.freebee.es/storage/app/media/bg-email.png" alt="cabeçalho">
        <h1 class="v-content-confirm-forget" v-contentConfirmForget="{ section: 'Account', removeHtml: true }">Esquecimento efetuado com sucesso!</h1>
    </div>
</template>

<script>
import axios from 'axios';
import store from "@/store";
import { mapState } from 'vuex';

const allContents = [];
const lang = localStorage.getItem('locale') || 'es';

export default {
    name: 'ConfirmForget',
    data() {
        return {
            token: '',
        }
    },
    computed: {
        ...mapState('App', ['loading', 'user']),
    },
    methods: {
        async confirmForget() {
            store.dispatch('App/loading', true);
            try{
                const response = await axios.post('/api/v1/user/confirm-forget', {
                    token: this.$route.params.token,
                    lang: lang
                },
                { withCredentials: true }
                );
                store.dispatch('App/loading', false);
                if (response.data.success) {
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Sucesso',
                        text: response.data.message,
                        timer: 5000,
                    });
                }
                else {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: response.error.error.message,
                        timer: 5000,
                    });
                    this.$router.push('/');
                }
            } catch (error) {
                store.dispatch('App/loading', false);
                this.$swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Ocorreu um erro ao confirmar o esquecimento. Tente novamente.',
                    timer: 5000,
                });
                this.$router.push('/');
            }
        },
        updateDirectives() {
            const allElements = document.querySelectorAll('.v-content-confirm-forget');
            allContents.splice(0, allContents.length); // clear the contents array
            allElements.forEach((el) => {
                const params = el.dataset.params ? JSON.parse(el.dataset.params) : {};
                params.content = el.innerHTML.trim();
                if (!('type' in params)) params.type = 'text';
                params.theme = process.env.VUE_APP_THEME;
                params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
                allContents.push(params);
            });
        },
    },
    created() {
        this.updateDirectives();
        this.confirmForget();
    },
    directives: {
        contentConfirmForget: {
            inserted: async function (el, binding) {
                const allElements = document.querySelectorAll('.v-content-confirm-forget');
                let params = binding.value ? binding.value : {};
                params.content = el.innerHTML.trim();
                if (!('type' in params)) params.type = 'text';
                params.theme = process.env.VUE_APP_THEME;
                params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
                allContents.push(params);

                if (allElements.length == allContents.length) {
                    store.dispatch('App/loading', true);
                    await axios({
                        method: "POST",
                        url: '/api/v1/site/get-all-contents',
                        data: { allContents, lang }
                    })
                    .then(response => response.data)
                    .then((data) => {
                        const allElements = document.querySelectorAll('.v-content-confirm-forget');
                        allContents.forEach((el) => {
                            if (el.type == 'text') {
                                allElements.forEach((el, index) => {
                                    el.innerHTML = data.data[index];
                                });
                            }
                        });
                        store.dispatch('App/loading', false);
                    });
                }
            },
        }
    },
}
</script>

<style lang="scss" scoped>
.confirm-forget {
    text-align: center;
    margin: 100px auto;
    max-width: 800px;
    img{
        max-width: 100%;
        margin-bottom: 50px;
    }
}

button {
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
}
</style>